<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Create new survey</h4>
</div>
<div class="modal-body">  
    <div class="row">
        <div class="col-md-8">
            <form class="form-horizontal col-md-12" role="form" [formGroup]="surveyForm" (ngSubmit)="onSubmit()">
                <div *ngIf="stage == 1">
                    <h4>Step 1: Input Survey Information</h4>
                    <div class="form-group">
                        <label class="col-md-4 col-form-label">Survey
                            Name:</label>
                        <div class="col-md-12">
                            <input class="form-control" fullWidth type="text" formControlName="title" required="true" placeholder="Survey Name">
                        </div>
                    </div> 
                    <br>
                    <div class="form-group">
                        <label class="col-md-12 col-form-label">
                            Does this survey have a Label ?
                        </label>
                        <div class="col-md-12">
                            <select class="custom-select mt-3" formControlName="hasSurvey">
                                <option value="1">Yes</option>
                                <option value="2">No</option>
                            </select>
                        </div>
                    </div>
                    <br>
                    <div class="form-group">
                        <label class="col-md-4 col-form-label">Survey
                            Content / Intent:</label>
                        <div class="col-md-12">
                            <textarea class="form-control" fullWidth formControlName="content" rows="5" [ngClass]="{ 'is-invalid': submitted &&
                                f.content?.errors }" placeholder="Survey content/ Intent"></textarea>
                        </div>
                    </div> 
                    <br>
                    <div>
                        <button type="submit" class="btn btn-dark btn-rounded" (click)="stage = 2">Add Questions </button> 
                    </div>
                </div>
                <div *ngIf="stage == 2">
                    <div *ngIf="currentMode == 'creating'">
                        <h4>Step 2: Input Survey Questions</h4>
                        <div class="form-group">
                            <label class="col-md-12 col-form-label">Question {{qust_num}}:</label>
                            <div class="col-md-12">
                                <input type="text" class="form-control" fullWidth formControlName="question" placeholder="enter the question you want users to answer here...">
                                <div *ngIf="submitted  && f.question.errors " class="invalid-feedback">
                                    <div *ngIf="f.question.errors.required">Question is required</div>
                                </div>
                            </div> 
                            <br>
                            <label class="col-md-12 col-form-label">Options For Users To Select:</label>
                            <div class="col-md-12">
                                <input *ngFor="let option of options; let a=index;" formControlName="choice{{a+1}}" class="form-control choice-input" fullWidth type="text" required placeholder="Answer Option {{a+1}} {{a>1 ? '(Optional)':''}}">
                                <!-- <div [hidden]="!submitted" class="invalid-feedback">
                                    <div [hidden]="!surveyForm.controls['choice' + 1].hasError('required')" >Question is required</div>
                                </div> -->
                                <!-- *ngIf="choice{{a+1}}.required" -->
                                <!-- <p *ngIf="options.length <3" style="text-decoration: underline; color: #59983f" (click)="increaseOptions()">
                                    <i class="fa fa-plus"></i> add more options
                                </p> -->
        
                                <button *ngIf="options.length <4" type="button" class="btn btn-2 btn-sm" (click)="increaseOptions()">
                                    <i class="fa fa-plus"></i> add option
                                </button>
                                <br>
        
                                <p  *ngIf="options.length > 2" style="text-decoration: underline; color: red;float: right;" (click)="decreaseOptions()">
                                    <i class="fa fa-close"></i> remove last option
                                </p>
                            </div>
                            <button type="button" class="btn btn-1 btn-block" (click)="addMoreQuestion()">
                                + Add Question
                            </button>
                
                        </div> <br>
                        <button type="submit" class="btn btn-dark btn-rounded" [disabled]="loading ||  surveyForm.invalid"><span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>Create Survey </button>

                    </div>
                    <div *ngIf="currentMode == 'editing'">
                        <form class="form-horizontal col-md-12" role="form" [formGroup]="editForm" (ngSubmit)="onSubmit()">
                            <h4>Edit Survey Questions</h4>
                            <div class="form-group">
                                <label class="col-md-12 col-form-label">Question {{qust_num}}:</label>
                                <div class="col-md-12">
                                    <input type="text" class="form-control" fullWidth formControlName="question" placeholder="enter the question you want users to answer here...">
                                    <div *ngIf="submitted  && f.question.errors " class="invalid-feedback">
                                        <div *ngIf="f.question.errors.required">Question is required</div>
                                    </div>
                                </div> <br>

                            <br>
                            <label class="col-md-12 col-form-label">Options For Users To Select:</label>
                            <div class="col-md-12">
                                <input *ngFor="let option of editQuestionOptions; let v=index;" formControlName="choice{{v+1}}" class="form-control choice-input" fullWidth type="text" required placeholder="Answer Option {{v+1}} {{v>1 ? '(Optional)':''}}">
                                <button *ngIf="options.length <4" type="button" class="btn btn-2 btn-sm" (click)="increaseEditOptions()">
                                    <i class="fa fa-plus"></i> add option
                                </button>
                                <br>
        
                                <p  *ngIf="options.length > 2" style="text-decoration: underline; color: red;float: right;" (click)="decreaseEditOptions()">
                                    <i class="fa fa-close"></i> remove last option
                                </p>
                            </div>
                                <button type="button" class="btn btn-success btn-block" (click)="saveQuestionChanges()">
                                    Save Changes
                                </button>
                    
                            </div>
                            
                            <button type="submit" class="btn btn-dark btn-rounded" [disabled]="loading ||  surveyForm.invalid"><span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>Create Survey </button>
                        </form>
                    </div>
                </div>
            </form>
        </div>
        <div class="col-md-4">
            <p class="q-txt-0">Created Questions</p>
            <div>
                <!-- *ngFor="let option of options; let a=index;" -->
                <div *ngFor="let question of questions; let i=index;" class="single-question">
                    <p class="q-txt-1">{{i+1}}. {{question.content}}</p>
                    <div>
                        <p *ngFor="let choice of returnArray(question.choices); let a=index;"><i class="fa fa-check-square"></i> {{choice.text}}</p>
                    </div>

                    <!--float: right; border: solid #666 1px;
                        <p style="text-decoration: underline; color: rgb(9, 27, 126)" (click)="increaseOptions()"> -->
                    <button type="button" style="text-decoration: underline;" class="btn btn-sm" (click)="editQuestion(question, i)">
                        <i class="fa fa-edit"></i> Edit Question
                    </button>
                    <!-- <br/> -->
                    <!-- </p> -->
                </div>
            </div>
            <div *ngIf="questions.length < 1">
                <i>No questions created</i>
            </div>
        </div>
    </div>
</div>